import React, { useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import {
  Alert,
  Button,
  Col,
  FormInput,
  FormInputText,
  FormInputSelect,
  Row,
} from 'camino-react'
import { cloudhelpPost } from 'Utilities/CloudHelp'

const UserCreateForm = ({ currentUser, clientId, groupsOptions, afterSave, onCancel }) => {
  const defaultGroupOption = _.find(groupsOptions, ['label', 'User'])
  const [user, setUserField] = useState({ name: '', email: '', group_id: defaultGroupOption.value })
  const [submissionText, setSubmissionText] = useState('Submit')
  const [errors, setErrors] = useState({})

  const submit = () => {
    setSubmissionText('Submitting...')
    cloudhelpPost(`/api/clients/${clientId}/users`, { user })
      .then((response) => {
        setSubmissionText('Submitted!')
        afterSave(response)
      })
      .catch((error) => {
        const errorResponse  = error.response.data.errors
        setSubmissionText('Submit')
        setErrors(errorResponse)
      })
  }

  const { name, email, group_id } = user

  return (
    <Row>
      <Col>
        <Row>
          <Col>
            <Alert type={_.some(errors) ? 'error' : 'info'} close>
              {_.some(errors) ? (errors) : 'Your ticket is still in the background.'}
            </Alert>
          </Col>
        </Row>

        <Row classExtra='row--bottom-spaced'>
          <Col>
            <FormInput label='Name'>
              <FormInputText
                value={name}
                onValue={value => setUserField({ ...user, name: value })}
              />
            </FormInput>
          </Col>
        </Row>

        <Row classExtra='row--bottom-spaced'>
          <Col>
            <FormInput label='Email'>
              <FormInputText
                value={email}
                onValue={value => setUserField({ ...user, email: value })}
              />
            </FormInput>
          </Col>
        </Row>

        {currentUser.calligo_employee && (
          <Row classExtra='row--bottom-spaced'>
            <Col>
              <FormInput label='Permission Group'>
                <FormInputSelect
                  value={_.find(groupsOptions, ['value', group_id])}
                  onValue={value => setUserField({ ...user, group_id: value })}
                  options={groupsOptions}
                />
              </FormInput>
            </Col>
          </Row>
        )}

        <Row>
          <Col classExtra='flex flex--space-evenly'>
            <Button outline onClick={() => onCancel()}>
              Cancel
            </Button>

            <Button onClick={() => submit()}>
              {submissionText}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default UserCreateForm

UserCreateForm.propTypes = {
  clientId: PropTypes.number.isRequired,
  groupsOptions: PropTypes.arrayOf(PropTypes.object),
  currentUser: PropTypes.shape({ calligo_employee: PropTypes.bool }),
  afterSave: PropTypes.func,
}

UserCreateForm.defaultProps = {
  groupsOptions: [],
  afterSave: () => undefined,
  currentUser: { calligo_employee: false }
}
